import { render, staticRenderFns } from "./LiveVideo.vue?vue&type=template&id=aefedd32&scoped=true"
import script from "./LiveVideo.vue?vue&type=script&lang=js"
export * from "./LiveVideo.vue?vue&type=script&lang=js"
import style0 from "./LiveVideo.vue?vue&type=style&index=0&id=aefedd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefedd32",
  null
  
)

export default component.exports